/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import { getIn, useFormikContext } from 'formik';
import React, { useEffect, useId } from 'react';

import FormError from './common/FormError';

const TextArea = (props) => {
  const {
    field,
    form,
    label,
    labelSROnly = false,
    type = 'text',
    required = false,
    placeholder,
    autoComplete = 'off',
    normalize,
    describedByLabel,
    describedByContent,
    maxLength,
    inputMode,
    autoFocus,
    onFocus,
    onBlur,
    displayErrors = true,
    innerRef,
    onChange,
    disabled,
    rows
  } = props;

  const fieldId = useId();
  const formikContext = useFormikContext();
  const { setFieldValue } = formikContext;

  const { name, onChange: onFieldChange, onBlur: onFieldBlur, value } = field;
  const { values } = form;

  useEffect(() => {
    if (normalize && value) {
      setFieldValue(name, normalize(String(value), value, values), false);
    }
  }, []); // eslint-disable-line

  const { id = `c7-${fieldId}-${name}` } = props;
  const { touched, errors } = form;

  const error = getIn(errors, name);
  const touch = getIn(touched, name);

  const labelId = `${id}-label`;
  const errorId = `${id}-error`;

  const handleOnChange = (e) => {
    let newEvent = e;
    if (normalize) {
      const newValue = normalize(e.target.value, value, values);
      newEvent = { target: { value: newValue, id: name, name } };
    }

    onFieldChange(newEvent);
    if (onChange) {
      setTimeout(() => onChange(newEvent), 1);
    }
  };

  const handleOnFocus = (e) => {
    if (onFocus) {
      onFocus(e);
    }
  };

  const handleOnBlur = (e) => {
    onFieldBlur(e);
    if (onBlur) {
      setTimeout(() => onBlur(e), 1);
    }
  };

  let ariaDescribedBy;
  if (describedByLabel) {
    ariaDescribedBy = describedByLabel;
  }
  if (touch && error) {
    ariaDescribedBy = errorId;
  }

  return (
    <div className="c7-form__field">
      <label
        htmlFor={id}
        id={labelId}
        className={classNames(
          required && 'c7-required',
          labelSROnly && 'c7-sr-only'
        )}
      >
        {label}
      </label>
      <textarea
        {...field}
        ref={innerRef}
        type={type}
        aria-required={required}
        required={required}
        name={name}
        id={id}
        onFocus={handleOnFocus}
        onChange={handleOnChange}
        onBlur={handleOnBlur}
        aria-describedby={ariaDescribedBy}
        aria-labelledby={labelId}
        autoComplete={autoComplete}
        placeholder={placeholder}
        maxLength={maxLength}
        inputMode={inputMode}
        aria-invalid={!!error && touch}
        disabled={disabled}
        rows={rows}
        /* TODO Andrea - autofocus and usability */
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
      />
      {describedByContent}
      {displayErrors && (
        <FormError touch={touch} error={error} id={errorId} label={label} />
      )}
    </div>
  );
};

export default TextArea;
